<template>
  <div>
    <edit-page-header
      page="WOD"
      :date="date"
    >
      <el-button
        class="light-gray"
        @click="handleClickCancel"
      >
        취소
      </el-button>

      <el-loading-button
        class="black"
        :disabled="!isFormValidated"
        :is-loading="isSaveWorkout"
        @click="handleClickSave"
      >
        등록
      </el-loading-button>
    </edit-page-header>

    <div class="notice-form">
      <el-form
        :model="form"
        label-position="top"
        label-width="100px"
      >
        <el-form-item
          label="내용"
          prop="contents"
        >
          <quill-editor
            class="editor"
            :options="editorOption"
            :content="form.contents"
            @change="onEditorChange($event)"
          />
        </el-form-item>

        <div class="upload-form">
          <ImageUploadField
            v-model="form.images"
            :initialFileList="initialFileList"
            :usage="3"/>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor, Quill } from "vue-quill-editor";
import autoLinks from 'quill-auto-links'
import dateFns from "date-fns";
import EditPageHeader from "@/components/EditPageHeader";
import ElLoadingButton from "@/components/el-loading-button";
import ImageUploadField from "@/components/ImageUploadField";
import { fiflboxApi } from '@/utils/api';
Quill.register('modules/autoLinks', autoLinks)

export default {
	name: "WorkoutEditForm",
	components: {ImageUploadField, ElLoadingButton, EditPageHeader, quillEditor },
	props: ["data"],
	data() {
		return {
			workoutId: null,
			date: null,
			editorOption: {
				placeholder: "",
				modules: {
					autoLinks: true,
					toolbar: [
						[
              { header: [1, 2, 3, 4, false] },
              "bold",
              "italic",
              "underline",
              { color: [] },
              { background: [] },
              { align: [] },
              { list: "bullet" },
              "link",
						]
					],
				},
			},
			isSaveWorkout: false,
      initialFileList: [],
			form: {
				date: "",
				contents: "",
				images: [],
			},
		};
	},
	computed: {
		isFormValidated() {
			return this.form.contents.length > 0;
		},
		presentDate() {
			return dateFns.format(this.date, "YYYY.MM.DD");
		},
	},
	async created() {
		if (this.$route.name === "main/wod/edit") {
			this.workoutId = this.$route.params.workoutId;
			await this.syncData();
		}

		if (this.$route.query.date) {
			this.date = dateFns.parse(this.$route.query.date);
		}
	},
	methods: {
		onEditorChange({ quill, html, text }) {
			this.form.contents = html;
		},
		async handleClickSave() {
			const errMsg = {
				title : '형식 오류',
				contents : '현재 사용 중인 폰트색상을 인식 할 수 없습니다.\n에디터의 폰트색상을 이용하세요.'
			}
			this.isSaveWorkout = true;

			if (this.$route.name === "main/wod/edit") {
				try {
          await fiflboxApi.v1.putWods(this.workoutId, this.form);
					this.$message(`오늘의 운동이 수정됐습니다.`);
					return this.$router.replace(`/dashboard`).catch(()=>{});
				} catch (err) {
					this.$alert(errMsg.contents,errMsg.title)
					return (this.isSaveWorkout = false);
				}
			}

			try {
				this.form.date = this.$route.query.date;
        await fiflboxApi.v1.postWods(this.form);
				this.$message(`오늘의 운동이 등록됐습니다.`);
				return this.$router.replace(`/dashboard`).catch(()=>{});
			} catch (err) {
				this.$alert(errMsg.contents,errMsg.title)
				return (this.isSaveWorkout = false);
			}
		},
		async handleClickCancel() {
			if (this.$route.name === "main/notice/edit") {
				return this.$router.replace(`/wods/${this.workoutId}`).catch(()=>{});
			}

			return this.$router.replace("/dashboard").catch(()=>{});
		},
		async syncData() {
      let { data: notice } = await fiflboxApi.v1.getWodsById(this.workoutId)
			this.form = notice;
			this.date = dateFns.parse(notice.date);
			this.initialFileList = notice.images.map(image => {
				return {
					id: image.id,
					name: image.filename,
					url: image.image,
				};
			});
			this.form.images = notice.images.map(image => image.id);
		},
	},
};
</script>

<style lang="scss">
.notice-form {
	background-color: #ffffff;
	padding: 30px 25px;
	border-radius: 10px;

	.editor {
    height: 330px;
    margin-bottom: 34px;
	}
}

.upload-form {
  width: 330px;
  margin: 0;

  @media screen and (max-width: 768px) {
    width: 100%;
    margin-top: 45px;
  }
}
</style>
